import merge from 'lodash/merge';
import baseStyles from '../Base/Base.styles';
import {parseResponsiveProperty} from '@converdy/styles';
import {
  responsiveTextAlignment,
  default as responsiveAlignment,
} from '../Base/responsiveAlignment';
export default ({base, gap, size, padding, radius, iconColor}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      '--iconColor': iconColor,
      ...merge(
        parseResponsiveProperty((v) => {
          return v
            ? {
                '--gap': `${v}px`,
              }
            : {};
        }, gap),
        parseResponsiveProperty((c) => {
          return c ? {'--size': `${c}px`} : {};
        }, size),
        parseResponsiveProperty((c) => {
          return c ? {'--padding': `${c}`} : {};
        }, padding),
        parseResponsiveProperty((c) => {
          return c ? {'--radius': `${c}px`} : {};
        }, radius),
      ),
      '& .social-icons': responsiveAlignment(base.alignment),
    },
  };

  return jss;
};
